export class ImageSources {
  public static logo = `assets/logo.png`;
  public static logoSmall = `assets/logo-small.png`;
}
